import App from "./App.vue";
import auth from "./auth";
// import { api } from "./client";
import router from "./router/router";
import { useAuthenticationStore } from "./stores/authentication";
import "./styles/main.scss";
import axios from "axios";
import humanizeDuration from "humanize-duration";
import moment from "moment";
import { createPinia } from "pinia";
import { createApp } from "vue";
import { PromiseDialog } from "vue3-promise-dialog";
import VueGoodTablePlugin from "vue-good-table-next";
import "vue-good-table-next/dist/vue-good-table-next.css";
import { Tooltip } from "bootstrap";

const app = createApp(App);
app.use(router);
app.use(VueGoodTablePlugin);
app.use(createPinia());
// app.use(PromiseDialog);

app.directive('tooltip', {
  mounted(el: HTMLElement, binding: any) {
    const tooltip = new Tooltip(el, {
      title: binding.value, // Tooltip text passed as directive value
      trigger: 'hover',     // Tooltip trigger on hover
      placement: 'top',     // Tooltip position
    });
    // Attach tooltip instance to the element for later use
    (el as HTMLElement)._tooltip = tooltip;
  },
  beforeUnmount(el: HTMLElement) {
    if ((el as HTMLElement)._tooltip) {
      (el as HTMLElement)._tooltip.dispose();
    }
  },
});

app.mount("#app");

auth.getUser().then((user) => {
  useAuthenticationStore().setUser(user);
  // if (user) {
  // client.package.packageMonitorRequest().then(() => {
  //   client.connectPackageMonitor();
  // });
  // }
})
.finally(() => {
  if (!useAuthenticationStore().user) return;
  useAuthenticationStore().decodeJwt();
  // useAuthenticationStore().setRoles(
  //   useAuthenticationStore().user?.profile.groups
  // );
 
}
);

interface Filters {
  [key: string]: (...value: any[]) => string;
}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $filters: Filters;
  }
}

app.config.globalProperties.$filters = {
  formatBreadcrumbs(value) {
    const breadcrumb = "";
    return breadcrumb;
  },
  formatDate(value: string) {
    if (value === "-" || value === "") {
      return "-";
    }
    const date = new Date(value);
    return moment(date).format("DD MMM yyyy");
  },
  formatDateAndTime(value: string) {
    if (value === "-" || value === "") {
      return "-";
    }
    const date = new Date(value);
    return moment(date).format("DD MMM yyyy | HH:mm:ss");
  },
  formatDateTimeString(value: string) {
    const date = new Date(value);
    return date.toLocaleString();
  },
  formatSizeUnits(bytes) {
    // if (bytes >= 1073741824) {
    //   bytes = (bytes / 1073741824).toFixed(2) + " GB";
    // } else if (bytes >= 1048576) {
    //   bytes = (bytes / 1048576).toFixed(2) + " MB";
    // } else if (bytes >= 1024) {
    //   bytes = (bytes / 1024).toFixed(2) + " KB";
    // } else if (bytes > 1) {
    //   bytes = bytes + " bytes";
    // } else if (bytes == 1) {
    //   bytes = bytes + " byte";
    // } else {
    //   bytes = "0 bytes";
    // }


    if (bytes >= 1073741824) {
      bytes = (bytes / 1073741824).toFixed(2) + " GB";
    } else  {
      bytes = (bytes / 1048576).toFixed(2) + " MB";
    } 
    return bytes;
  },

  formatDateTime(value: Date | undefined) {
    if (!value) {
      return "";
    }
    return value.toLocaleString();
  },
  formatDuration(from: Date, to: Date) {
    const diff = moment(to).diff(from);
    return humanizeDuration(moment.duration(diff).asMilliseconds());
  },

  formatTimeDuration(from: Date, to: Date) {
    const diff = moment(to).diff(from);
    const hours =
      moment.duration(diff).days() * 24 + moment.duration(diff).hours();
    if (hours < 24) {
      return moment.utc(diff).format("HH:mm:ss");
    }
    return hours + ":" + moment.utc(diff).format("mm:ss");
  },

  formatCurrentDateTime() {
    return moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
  },
  formatUnixDateTime(value: number) {
    if (value === null) {
      return "-";
    }
    return moment.unix(value).format("DD MMM yyyy | HH:mm:ss");
  },

  formatUnixDate(value: number) {
    if (value === null) {
      return "-";
    }
    return moment.unix(value).format("DD MMM yyyy ");
  },
  // formatPreservationActionStatus(
  //   value: api.EnduroPackagePreservationActionsActionResponseBodyStatusEnum
  // ) {
  //   switch (value) {
  //     case api.EnduroPackagePreservationActionsActionResponseBodyStatusEnum
  //       .Complete:
  //       return "bg-success";
  //     case api.EnduroPackagePreservationActionsActionResponseBodyStatusEnum
  //       .Failed:
  //       return "bg-danger";
  //     case api.EnduroPackagePreservationActionsActionResponseBodyStatusEnum
  //       .Processing:
  //       return "bg-warning";
  //     default:
  //       return "bg-secondary";
  //   }
  // },
};

// const userStore = useAuthenticationStore();
// auth.getUser().then((user) => userStore.setUser(user));

// axios.interceptors.request.use(async (request) => {
//   if (
//     request.url?.startsWith(import.meta.env.VITE_TYPESENSE_URL) &&
//     request.headers
//   ) {
//     await userStore.fetchSearchKey();
//     // TODO: use `userStore.getSearchKey` after solving downloads scope.
//     request.headers["X-TYPESENSE-API-KEY"] = "typesenseapikey";
//   }

//   return request;
// });

// axios.interceptors.response.use((response) => {
//   if (
//     response.config.url?.startsWith(import.meta.env.VITE_TYPESENSE_URL) &&
//     response.status == 401
//   ) {
//     userStore.removeSearchKey();
//   }
//   return response;
// });
